// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__368Ns","toggleWrap":"styles_toggleWrap__3XVpX","content":"styles_content__Df-6l","selectAreaCode":"styles_selectAreaCode__1RIs3"};